module.exports = __webpack_public_path__ + "static/img/service11.2391ebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/service11.png
// module id = D/Nr
// module chunks = 1 2